import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { imgBaseUrl } from "../../../api/api";
import { formatDate, SweetAlertShow } from "../../master/Master";
import { staffLowAttendanceData } from "../../../api/Attendance";

export default function StaffLowAttendanceList({
    filters = {},
    permissions = [],
    setModalData = () => { },
}) {
    const [staffs, setStaffs] = useState([]);

    const getStaffs = async () => {
        let addUrl = "";

        Object.keys(filters || {}).forEach((key) => {
            if (
                filters[key] !== "" &&
                filters[key] !== null &&
                filters[key] !== undefined
            ) {
                addUrl += `&${key}=${encodeURIComponent(filters[key])}`;
            }
        });

        addUrl += "&type=list";

        try {
            const response = await staffLowAttendanceData(addUrl);

            if (response?.data?.status) {
                setStaffs(response.data.data || []);
            } else {
                SweetAlertShow("info", "Warning", response?.data?.message);
            }
        } catch (error) {
            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message ?? error?.message
            );
        }
    };

    useEffect(() => {
        getStaffs();
    }, [JSON.stringify(filters)]);

    return (
        <div className=" table-responsive" id="PrintDiv">
            <table className="table align-middle table-hover">
                <thead className="table-light">
                    <tr>
                        <th>#</th>
                        <th>Employee</th>
                        <th>Contact</th>
                        <th>Role</th>
                        <th>Joining Date</th>
                        <th>Status</th>
                    </tr>
                </thead>

                <tbody>
                    {staffs.length ? (
                        staffs.map((item, i) => (
                            <tr
                                key={item.id}
                                style={{ cursor: "pointer" }}
                                onClick={() => window.location.href = `/teachers/view/${item.id}`}
                            >
                                <td>{i + 1}</td>

                                <td>
                                    <div className="d-flex align-items-center">
                                        {item.img ? (
                                            <img
                                                src={`${imgBaseUrl}${item.img}`}
                                                className="rounded-circle me-2"
                                                width="45"
                                                height="45"
                                                alt=""
                                            />
                                        ) : (
                                            <div
                                                className="rounded-circle bg-label-primary d-flex align-items-center justify-content-center me-2"
                                                style={{
                                                    width: 45,
                                                    height: 45,
                                                }}
                                            >
                                                {item.name
                                                    ?.split(" ")
                                                    ?.map((x) => x[0])
                                                    ?.slice(0, 2)
                                                    ?.join("")}
                                            </div>
                                        )}

                                        <div>
                                            <div>{item.name}</div>

                                            <small className="text-muted">
                                                {item.registration_no}
                                            </small>
                                        </div>
                                    </div>
                                </td>

                                <td>{item.mobile}</td>

                                <td>
                                    <span className="badge bg-label-info">
                                        {item.staff_type}
                                    </span>
                                </td>

                                <td>
                                    {formatDate(item?.employment_info?.joining_date)}
                                </td>

                                <td>
                                    <span
                                        role="button"
                                        className={`badge ${item.status == "1"
                                            ? "bg-label-success"
                                            : "bg-label-danger"
                                            }`}
                                        data-bs-toggle="modal"
                                        data-bs-target={
                                            item.status == "1"
                                                ? "#staff_inactive"
                                                : "#staff_rejoin"
                                        }
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setModalData(item);
                                        }}
                                    >
                                        {item.status == "1" ? "Active" : "Inactive"}
                                    </span>
                                </td>


                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="6" className="text-center py-5">
                                No Staff Found
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}